import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { CartFilled } from "@fluentui/react-icons";
import React from "react";
import { ResourcesData } from "../../models/flights/IFlightsCommon";
import { formatDisplayValue } from "../../utils/common/FormatHelper";
import CardHeader from "./CardHeader";
import { useCardStyles } from "./shared.styles";

export interface ResourcesCardProps {
  data: ResourcesData;
  className?: string;
}

export const RESOURCE_FIELDS: { label: string; key: keyof ResourcesData }[] = [
  { label: "Gate", key: "gate" },
  { label: "Stand", key: "stand" },
  { label: "Belt", key: "belt" },
  { label: "Chute", key: "chute" },
  { label: "Handler", key: "groundHandler" },
];

const ResourcesCard: React.FC<ResourcesCardProps> = ({ data, className }) => {
  const shared = useCardStyles();
  const local = useLocalStyles();

  return (
    <article className={mergeClasses(shared.container, className)}>
      <CardHeader icon={<CartFilled />} title="Resources" primaryValue="" />

      <section className={mergeClasses(shared.content, local.content)}>
        <div className={local.centerWrapper}>
          {RESOURCE_FIELDS.map(({ label, key }) => (
            <div key={key} className={local.row}>
              <span className={local.label}>{label}</span>
              <span className={local.value}>
                {formatDisplayValue(data[key])}
              </span>
            </div>
          ))}
        </div>
      </section>
    </article>
  );
};

export default ResourcesCard;

const useLocalStyles = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  centerWrapper: {
    display: "inline-flex",
    flexDirection: "column",
    gap: "12px",
  },
  row: {
    display: "flex",
    alignItems: "flex-start",
    gap: "12px",
  },
  label: {
    width: "50px",
    textAlign: "right",
    paddingRight: "9px",
    fontSize: tokens.fontSizeBase300,
    color: tokens.colorNeutralForeground2,
    whiteSpace: "nowrap",
    flexShrink: 0,
  },
  value: {
    textAlign: "left",
    flex: 1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
    wordWrap: "break-word",
    overflowWrap: "break-word",
  },
});
